import { axios } from 'services/axios'
import { routes } from 'services/routes'
import { ApiPendingConversationsListResponse } from 'types/Api'

export const fetchPendingConversations = async () => {
  const response = await axios.get<ApiPendingConversationsListResponse>(
    routes.pendingConversationsListPath(),
  )
  if (!response) {
    throw new Error('Couldn\'t fetch processing conversations')
  }
  return response.data
}
